export default __webpack_public_path__ + "static/media/shopping-cart.b7f98c41.svg";